import React from 'react'
import { useState } from "react"
import { useSignup } from "../hooks/useSignup"
import T from "../../../components/Translation"
import { useAuthContext } from '../hooks/useAuthContext'
import FieldDropdown from '../../components/FieldDropdown'
import { generateMongoDBId } from '../../lib/utils'


const SignupForm = ({AuthContext}) => {
    const [email, setEmail] = useState('')
    const {user} = useAuthContext(AuthContext)
    const [invitationCode, setInvitationCode] = useState('')
    const [password, setPassword] = useState('')
    const [mindProId, setMindProId] = useState()
    const [companyId, setCompanyId] = useState()
    const [userType, setUserType] = useState({label: "User", value: "user"})

    const {signup, error, isLoading} = useSignup(AuthContext)
    //const {invitationOnly, setInvitationOnly} = useState(true) 
    const invitationOnly = true
  
    const handleSubmit = async (e) => {
      e.preventDefault()
      //process.env.NODE_ENV === "development" && console.log("2 ids", generateMongoDBId(), generateMongoDBId())
      //process.env.NODE_ENV === "development" && console.log("signup", {email, password, companyId: companyId?.value, mindProId: mindProId?.value, userType: userType?.value})
      await signup({email, password, companyId: companyId?.value, mindProId: mindProId?.value, userType: userType?.value, login: user?.userType == "godMode" ? false : true})
    }
    //process.env.NODE_ENV === "development" && console.log("user", user)
    const handleSendInvitation = async (e) => {
      e.preventDefault()
      process.env.NODE_ENV === "development" && console.log("sending invitation code:", invitationCode)
      //await signup(email, password)
    }

    const userTypes = [
      {label: "Admin", value: "admin"}, 
      {label: "Super Admin", value: "superAdmin"}, 
      {label: "Mind Professional", value: "mindPro"}, 
      {label: "User", value: "user"}
    ]
    const companies = [
      {label: "Action", value: "4cb0152d48da6aefc69b8a4a"}, 
      {label: "Allianz", value: "0a8787e70e71aa2e3c993a0c"}
    ]

    //   <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "30px"}}>
    if (invitationOnly && user?.userType !== "godMode") {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "30px"}}>
          <h3>
              <T obj={{
                it: "Al momento l'accesso all'area protetta è consentito solo su invito, se hai un codice di invito, inseriscilo qui sotto:", 
                en: "At the moment, access to the protected area is only allowed by invitation. If you have an invitation code, please enter it below:"
              }}/>
               <form style ={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}} className="signup" onSubmit={handleSendInvitation}>
                <input 
                  type="text" 
                  onChange={(e) => setInvitationCode(e.target.value)} 
                  value={invitationCode} 
                />
                <button disabled={false}>              
                    <T obj={{
                      it: "Spedisci Codice Invito", 
                      en: "Send Invitation Code"
                    }}/>
              </button>
                {error && <div className="error">{error}</div>}
              </form>

            </h3>
        </div>
      )
    }
    return (
      <form className="signup" onSubmit={handleSubmit}>
        <h3>Sign Up</h3>
        
        <label>Email address:</label>
        <input 
          type="email" 
          onChange={(e) => setEmail(e.target.value)} 
          value={email} 
        />
        <label>Password:</label>
        <input 
          type="password" 
          onChange={(e) => setPassword(e.target.value)} 
          value={password} 
        />
        <FieldDropdown
          options={userTypes}
          placeHolder={"Select User Type"}
          value={userType}
          onChange={(value) => setUserType(value)}
        />
        <FieldDropdown
          options={companies}
          value={companyId}
          placeHolder={"Select Company"}
          onChange={(value) => setCompanyId(value)}
        />
        <button disabled={isLoading}>Sign up</button>
        {error && <div className="error">{error}</div>}
      </form>
    )
  }

export default SignupForm
